import { render, staticRenderFns } from "./o-masked-input.vue?vue&type=template&id=3fa2cfae&scoped=true&"
import script from "./o-masked-input.vue?vue&type=script&lang=js&"
export * from "./o-masked-input.vue?vue&type=script&lang=js&"
import style0 from "./o-masked-input.vue?vue&type=style&index=0&id=3fa2cfae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa2cfae",
  null
  
)

export default component.exports